import { createBrowserRouter } from 'react-router-dom';
import Login from '../pages/login.js';
import ForgotPassword from '../pages/ForgotPassword.js';
import { Layout } from '../components/layout/Layout';
import Dashboard from '../pages/Dashboard';
import { UserManagement } from '../pages/UserManagement.js';
import { Role } from '../pages/Role.js';
import { Permission } from '../pages/Permission.js';
import Loginn from '../pages/Authentication/Login1.js';
import BulkImport from '../pages/bulkImport.js';
import SchedulerDialogComponent from '../pages/schedule-timing.js';
import EmailNotification from '../pages/emailNotification.js';

import SchedulerComponent from '../pages/Scheduler.js';
import Notifications from '../pages/Notifications.js';
import AuthGuard from '../components/guards/AuthGuard'; // Import the AuthGuard
import Firmware from '../pages/firmware.js';

// import NotifyComponent from '../pages/notify.js';
import Profile from '../pages/profile.js';
import ReleaseNotes from '../pages/ReleaseNotes.js';
import Reports from '../pages/Reports.js';
import LandingPage from '../landing/LandingPage.js';
import UsersPage from '../pages/users.js';
import RolesPage from '../pages/roles.js';
import GroupsPage from '../pages/groups.js';
import PermissionsPage from '../pages/permissions.js';
import PoliciesPage from '../pages/policies.js';
import UrlsPage from '../pages/whitelisturls.js';
import ProtocolRulesPage from '../pages/ProtocolRulesPage.js';
import ActiveSessions from '../pages/ActiveSessions.js';
import LatestBrowserUpdates from '../pages/LatestBrowserUpdates.js';
import Devices from '../pages/Devices.js';
import Questionnaire from '../pages/Questionnaire.js';
import CustomChartsPage from '../pages/CustomChartsPage.js';

const router = createBrowserRouter([
  {
    path: '/',
    element: <Login />
  },
  // {
  //   path: '/',
  //   element: <LandingPage />
  // },
  {
    path: '/forgot-password',
    element: <ForgotPassword />
  },
  {
    // Protected routes are wrapped with AuthGuard
    element: <AuthGuard />,
    children: [
      {
        path: '/',
        element: <Layout />, // Layout that wraps all inner pages
        children: [
          {
            path: 'home',
            element: <Dashboard />
          },
          {
            path: 'asset',
            element: <Firmware />
          },
          {
            path: 'user-management',
            element: <UserManagement />
          },
          {
            path: 'role',
            element: <Role />
          },
          {
            path: 'permission',
            element: <Permission />
          },
          {
            path: 'loginn',
            element: <Loginn />
          },
          {
            path: 'bulk-import',
            element: <BulkImport />
          },
          {
            path: 'scheduler',
            element: <SchedulerDialogComponent />
          },
          {
            path: 'email-scheduler',
            element: <EmailNotification />
          },
       
          {
            path: 'scheduler1',
            element: <SchedulerComponent />
          },
          {
            path: 'notifications',
            element: <Notifications />
          },
          {
            path: 'TestComponent',
            element: <ForgotPassword />
          },
          {
            path: 'profile',
            element: <Profile />
          },
          {
            path: 'urls',
            element: <UrlsPage />
          },
          {
            path: 'policies',
            element: <PoliciesPage />
          },
           {
            path: 'users',
            element: <UsersPage />
          },
             {
            path: 'roles',
            element: <RolesPage />
          },
            {
            path: 'groups',
            element: <GroupsPage />
          },
            {
            path: 'permissions',
            element: <PermissionsPage />
          },
            {
            path: 'protocols',
            element: <ProtocolRulesPage />
          },
              {
            path: 'active-sessions',
            element: <ActiveSessions />
          },
                {
            path: 'browser-updates',
            element: <LatestBrowserUpdates />
          },
                 {
            path: 'devices',
            element: <Devices />
          },
  {
  path: 'questionnaire',
  element: <Questionnaire />
},
{
  path: 'custom-charts',
  element: <CustomChartsPage />
}

        ]
      }
    ]
  }
]);

export default router;
